import Loadable from '../../../components/loadable';

const ConfirmSendWaiverToChild = Loadable({
  loader: () => import('../../../pages/contacts/waivers/confirm_send_waiver_to_child'),
  type: 'modal',
});

angular.module('gym').value('ConfirmSendWaiverToChild', ConfirmSendWaiverToChild);
